// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../asstes/images/bgimage.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.view-container {
    margin-top: 20px;
    padding-left: 3.75rem;
    padding-right: 3.75rem;
}

.bgimage-container {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 427px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding-left: 7.375rem;
}

.sub-title {
    font-size: 1rem;
    line-height: 1.28rem;
    color: #FFFFFF;
    text-transform: uppercase;
    font-family: 'Lora-Regular';
}

.main-title {
    font-size: 5rem;
    line-height: 6.4rem;
    color: #FFFFFF;
    text-transform: capitalize;
    font-family: 'Lora-Regular';
}

.react-calendar__navigation__prev2-button,
.react-calendar__navigation__next2-button {
    display: none;
}

.appointment-view {
    background-color: #294859;
    padding: 2.188rem 3.5rem;
    /* margin: -8.25rem 4.313rem 3.5rem; */
    border-radius: 20px;
}

.row-title {
    font-size: 1.25rem;
    line-height: 1.6rem;
    color: #ffffff;
    font-family: 'Lora-Regular';
    padding-bottom: 17px;
}

.doctor-carousel {
    margin-bottom: 50px;
}

.owl-nav {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: absolute;
    top: 50%;
    transform: translate(0%, -50%);
}

.owl-theme .owl-nav [class*='owl-']:hover {
    background: transparent !important;
    text-decoration: none;
}

.doc-nav-left {
    width: 30px;
    height: auto;
    margin-left: -59px;
    margin-top: -40px;
}

.doc-nav-right {
    width: 30px;
    height: auto;
    margin-right: -59px;
    margin-top: -40px;
}

.owl-dots {
    margin-top: 12px;
}

.calendar-view {
    /* width: 50%; */
    padding-right: 30px;
}

/* Custom styles for React Calendar */
.react-calendar {
    font-family: 'PublicSans-Regular';
    background-color: #FFFFFF;
    border-radius: 20px;
    border: none !important;
    width: 530px !important;
    padding: 20px !important;

}

.react-calendar__tile {
    background-color: #ffffff;
    border-radius: 100px;
    max-width: 40px !important;
    height: 40px;
    font-size: 18px !important;
    line-height: 20px !important;
    /* color: #344054 !important; */
    font-family: 'PublicSans-Regular' !important;
    font-weight: 500 !important;
    margin: 4px 0px !important;
}

.react-calendar__navigation button span {
    font-family: 'PublicSans-SemiBold';
    font-size: 16px !important;
    color: #344054;
}

.react-calendar__navigation button:enabled:hover,
.react-calendar__navigation button:enabled:focus {
    background-color: transparent !important;
}

.react-calendar__navigation button {
    font-size: 20px;
}

.react-calendar__month-view__days {
    display: grid !important;
    grid-template-columns: auto auto auto auto auto auto auto;
    grid-gap: 10px;
    margin-top: 3px;
}

.react-calendar__tile--active {
    background-color: #c7e5c9 !important;
    color: #000000 !important;
    position: relative;
}

.react-calendar__tile--active::after {
    content: '';
    width: 6px;
    height: 6px;
    background-color: #000;
    position: absolute;
    bottom: 4px;
    left: 18px;
    border-radius: 100px;
}

.react-calendar__tile--hover {
    background-color: #c7e5c9 !important;
}

.react-calendar__month-view__weekdays {
    text-transform: capitalize !important;
    font-size: 18px !important;
    line-height: 20px !important;
    color: #344054 !important;
    font-family: 'PublicSans-Regular' !important;
    font-weight: 500 !important;
    text-align: left !important;
}

abbr[title] {
    text-decoration: none !important
}

.bookappoiment-view {
    display: flex;
    flex-direction: row;
}

.slot-container {
    /* width: 50%; */
    padding-top: 20px;
    padding-bottom: 20px;
}

.selected-date {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
}

.selected-date p {
    color: #fff;
    font-size: 20px;
    line-height: 25.6px;
    font-family: 'Lora-Regular';
}

.calendar-outline {
    width: 24px;
    height: 24px;
    margin-right: 9px;
}

.slot-view h3 {
    font-size: 16px;
    line-height: 30px;
    font-family: 'PublicSans-SemiBold';
    color: #fff;
    padding-bottom: 20px;
}

.time-slot {
    border: 1px solid #294859;
    padding: 4px 12px;
    border-radius: 100px;
    background-color: transparent;
    font-size: 14px;
    line-height: 22px;
    font-family: 'PublicSans-Regular';
    color: #294859;
    margin-right: 20px;
    margin-bottom: 20px;
    background-color: #fff;
    width: 100px;
}

.note-style {
    font-size: 18px;
    line-height: 25px;
    font-family: 'PublicSans-Regular';
    color: #fff;
    margin-top: 6px;
}

.appoiment-btn-container {
    margin-top: 20px;
    text-align: center;
}

.appoiment-btn {
    border: 1px solid #FFFFFF;
    padding: 15px 28px;
    border-radius: 100px;
    background-color: #FFFFFF;
    font-size: 16px;
    line-height: 18.8px;
    font-family: 'PublicSans-Regular';
    color: #294859;
    cursor: pointer;
}

.react-calendar__navigation button:disabled {
    background-color: transparent !important;
}

.active-day {
    background-color: #c7e5c9 !important;
    color: #000000 !important;
}

.slot-dissabled {
    background-color: #fff;
    color: #344054;
    opacity: .5;
}

.active-slot {
    background-color: #edc35a;
    color: #ffffff;
    border: 1px solid #edc35a;
}

.slot-loader {
    font-size: 20px;
}

.react-calendar__month-view__days__day--weekend {
    color: #000000 !important;
}

.react-calendar__month-view__days__day--neighboringMonth,
.react-calendar__decade-view__years__year--neighboringDecade,
.react-calendar__century-view__decades__decade--neighboringCentury {
    color: #757575 !important;
}

.react-calendar__tile:disabled {
    background-color: #f0f0f0;
    color: #ababab !important;
}

.react-calendar__tile--now {
    background: #ffedb6 !important;
}

.owl-stage {
    display: flex;
}

.owl-item {
    display: flex;
    flex-direction: column;
}

/* .item {
    flex: 1;
    display: flex;
    flex-direction: column;
} */


@media (max-width:600px) {
    .view-container {
        padding-left: 20px;
        padding-right: 20px;
        margin-top: 80px;
    }

    .bgimage-container {
        padding-left: 2rem;
        height: 300px;
    }

    .appointment-view {
        /* margin: 0rem 1rem 3.5rem; */
        padding: 1rem 2rem;
    }

    .doc-nav-left {
        width: 24px;
        height: auto;
        margin-left: -42px;
    }

    .doc-nav-right {
        width: 24px;
        height: auto;
        margin-right: -41px;
    }

    .main-title {
        font-size: 40px;
        line-height: 40px;
        padding-top: 10px;
    }

    .calendar-view {
        padding-right: 0px
    }

    .react-calendar__month-view__weekdays {
        font-size: 12px !important;
    }

    .react-calendar__tile {
        font-size: 12px !important;
        height: 25px;
        padding: 0px !important;
    }

    .react-calendar__navigation button {
        min-width: 22px !important;
    }

    .selected-date p {
        font-size: 16px;
    }

    .react-calendar__tile--active::after {
        width: 4px;
        height: 4px;
        bottom: 2px;
        left: 11px;
    }

    .time-slot {
        padding: 4px 10px;
        font-size: 12px;
        line-height: 20px;
        margin-right: 5px;
        margin-bottom: 10px;
        width: 80px;
    }

    .note-style {
        font-size: 16px;
        line-height: 22px;
    }

    .appoiment-btn-container {
        margin-top: 0px;
    }

    .appoiment-btn {
        padding: 10px 20px;
        font-size: 14px;
    }

    .doctor_right_view h3 {
        font-size: 18px;
        line-height: 22px;
    }

    .doctor_right_view {
        font-size: 13px;
        line-height: 18px;
    }

    .react-calendar__navigation button span {
        font-size: 15px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/BookAppoiment/style.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,yDAAwD;IACxD,aAAa;IACb,2BAA2B;IAC3B,4BAA4B;IAC5B,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,cAAc;IACd,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,0BAA0B;IAC1B,2BAA2B;AAC/B;;AAEA;;IAEI,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;IACxB,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,2BAA2B;IAC3B,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,qCAAqC;AACrC;IACI,iCAAiC;IACjC,yBAAyB;IACzB,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,wBAAwB;;AAE5B;;AAEA;IACI,yBAAyB;IACzB,oBAAoB;IACpB,0BAA0B;IAC1B,YAAY;IACZ,0BAA0B;IAC1B,4BAA4B;IAC5B,+BAA+B;IAC/B,4CAA4C;IAC5C,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;IACI,kCAAkC;IAClC,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;;IAEI,wCAAwC;AAC5C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,yDAAyD;IACzD,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;IAC1B,4BAA4B;IAC5B,yBAAyB;IACzB,4CAA4C;IAC5C,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI;AACJ;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,kCAAkC;IAClC,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,oBAAoB;IACpB,6BAA6B;IAC7B,eAAe;IACf,iBAAiB;IACjB,iCAAiC;IACjC,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,iCAAiC;IACjC,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,iCAAiC;IACjC,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;IACtB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;;IAGI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;;;GAIG;;;AAGH;IACI;QACI,kBAAkB;QAClB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,aAAa;IACjB;;IAEA;QACI,8BAA8B;QAC9B,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI;IACJ;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;QAC1B,YAAY;QACZ,uBAAuB;IAC3B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,WAAW;QACX,WAAW;QACX,UAAU;IACd;;IAEA;QACI,iBAAiB;QACjB,eAAe;QACf,iBAAiB;QACjB,iBAAiB;QACjB,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".view-container {\n    margin-top: 20px;\n    padding-left: 3.75rem;\n    padding-right: 3.75rem;\n}\n\n.bgimage-container {\n    background-image: url('../../asstes/images/bgimage.png');\n    height: 427px;\n    background-position: center;\n    background-repeat: no-repeat;\n    background-size: cover;\n    border-radius: 20px;\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    padding-left: 7.375rem;\n}\n\n.sub-title {\n    font-size: 1rem;\n    line-height: 1.28rem;\n    color: #FFFFFF;\n    text-transform: uppercase;\n    font-family: 'Lora-Regular';\n}\n\n.main-title {\n    font-size: 5rem;\n    line-height: 6.4rem;\n    color: #FFFFFF;\n    text-transform: capitalize;\n    font-family: 'Lora-Regular';\n}\n\n.react-calendar__navigation__prev2-button,\n.react-calendar__navigation__next2-button {\n    display: none;\n}\n\n.appointment-view {\n    background-color: #294859;\n    padding: 2.188rem 3.5rem;\n    /* margin: -8.25rem 4.313rem 3.5rem; */\n    border-radius: 20px;\n}\n\n.row-title {\n    font-size: 1.25rem;\n    line-height: 1.6rem;\n    color: #ffffff;\n    font-family: 'Lora-Regular';\n    padding-bottom: 17px;\n}\n\n.doctor-carousel {\n    margin-bottom: 50px;\n}\n\n.owl-nav {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: absolute;\n    top: 50%;\n    transform: translate(0%, -50%);\n}\n\n.owl-theme .owl-nav [class*='owl-']:hover {\n    background: transparent !important;\n    text-decoration: none;\n}\n\n.doc-nav-left {\n    width: 30px;\n    height: auto;\n    margin-left: -59px;\n    margin-top: -40px;\n}\n\n.doc-nav-right {\n    width: 30px;\n    height: auto;\n    margin-right: -59px;\n    margin-top: -40px;\n}\n\n.owl-dots {\n    margin-top: 12px;\n}\n\n.calendar-view {\n    /* width: 50%; */\n    padding-right: 30px;\n}\n\n/* Custom styles for React Calendar */\n.react-calendar {\n    font-family: 'PublicSans-Regular';\n    background-color: #FFFFFF;\n    border-radius: 20px;\n    border: none !important;\n    width: 530px !important;\n    padding: 20px !important;\n\n}\n\n.react-calendar__tile {\n    background-color: #ffffff;\n    border-radius: 100px;\n    max-width: 40px !important;\n    height: 40px;\n    font-size: 18px !important;\n    line-height: 20px !important;\n    /* color: #344054 !important; */\n    font-family: 'PublicSans-Regular' !important;\n    font-weight: 500 !important;\n    margin: 4px 0px !important;\n}\n\n.react-calendar__navigation button span {\n    font-family: 'PublicSans-SemiBold';\n    font-size: 16px !important;\n    color: #344054;\n}\n\n.react-calendar__navigation button:enabled:hover,\n.react-calendar__navigation button:enabled:focus {\n    background-color: transparent !important;\n}\n\n.react-calendar__navigation button {\n    font-size: 20px;\n}\n\n.react-calendar__month-view__days {\n    display: grid !important;\n    grid-template-columns: auto auto auto auto auto auto auto;\n    grid-gap: 10px;\n    margin-top: 3px;\n}\n\n.react-calendar__tile--active {\n    background-color: #c7e5c9 !important;\n    color: #000000 !important;\n    position: relative;\n}\n\n.react-calendar__tile--active::after {\n    content: '';\n    width: 6px;\n    height: 6px;\n    background-color: #000;\n    position: absolute;\n    bottom: 4px;\n    left: 18px;\n    border-radius: 100px;\n}\n\n.react-calendar__tile--hover {\n    background-color: #c7e5c9 !important;\n}\n\n.react-calendar__month-view__weekdays {\n    text-transform: capitalize !important;\n    font-size: 18px !important;\n    line-height: 20px !important;\n    color: #344054 !important;\n    font-family: 'PublicSans-Regular' !important;\n    font-weight: 500 !important;\n    text-align: left !important;\n}\n\nabbr[title] {\n    text-decoration: none !important\n}\n\n.bookappoiment-view {\n    display: flex;\n    flex-direction: row;\n}\n\n.slot-container {\n    /* width: 50%; */\n    padding-top: 20px;\n    padding-bottom: 20px;\n}\n\n.selected-date {\n    display: flex;\n    align-items: center;\n    margin-bottom: 30px;\n}\n\n.selected-date p {\n    color: #fff;\n    font-size: 20px;\n    line-height: 25.6px;\n    font-family: 'Lora-Regular';\n}\n\n.calendar-outline {\n    width: 24px;\n    height: 24px;\n    margin-right: 9px;\n}\n\n.slot-view h3 {\n    font-size: 16px;\n    line-height: 30px;\n    font-family: 'PublicSans-SemiBold';\n    color: #fff;\n    padding-bottom: 20px;\n}\n\n.time-slot {\n    border: 1px solid #294859;\n    padding: 4px 12px;\n    border-radius: 100px;\n    background-color: transparent;\n    font-size: 14px;\n    line-height: 22px;\n    font-family: 'PublicSans-Regular';\n    color: #294859;\n    margin-right: 20px;\n    margin-bottom: 20px;\n    background-color: #fff;\n    width: 100px;\n}\n\n.note-style {\n    font-size: 18px;\n    line-height: 25px;\n    font-family: 'PublicSans-Regular';\n    color: #fff;\n    margin-top: 6px;\n}\n\n.appoiment-btn-container {\n    margin-top: 20px;\n    text-align: center;\n}\n\n.appoiment-btn {\n    border: 1px solid #FFFFFF;\n    padding: 15px 28px;\n    border-radius: 100px;\n    background-color: #FFFFFF;\n    font-size: 16px;\n    line-height: 18.8px;\n    font-family: 'PublicSans-Regular';\n    color: #294859;\n    cursor: pointer;\n}\n\n.react-calendar__navigation button:disabled {\n    background-color: transparent !important;\n}\n\n.active-day {\n    background-color: #c7e5c9 !important;\n    color: #000000 !important;\n}\n\n.slot-dissabled {\n    background-color: #fff;\n    color: #344054;\n    opacity: .5;\n}\n\n.active-slot {\n    background-color: #edc35a;\n    color: #ffffff;\n    border: 1px solid #edc35a;\n}\n\n.slot-loader {\n    font-size: 20px;\n}\n\n.react-calendar__month-view__days__day--weekend {\n    color: #000000 !important;\n}\n\n.react-calendar__month-view__days__day--neighboringMonth,\n.react-calendar__decade-view__years__year--neighboringDecade,\n.react-calendar__century-view__decades__decade--neighboringCentury {\n    color: #757575 !important;\n}\n\n.react-calendar__tile:disabled {\n    background-color: #f0f0f0;\n    color: #ababab !important;\n}\n\n.react-calendar__tile--now {\n    background: #ffedb6 !important;\n}\n\n.owl-stage {\n    display: flex;\n}\n\n.owl-item {\n    display: flex;\n    flex-direction: column;\n}\n\n/* .item {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n} */\n\n\n@media (max-width:600px) {\n    .view-container {\n        padding-left: 20px;\n        padding-right: 20px;\n        margin-top: 80px;\n    }\n\n    .bgimage-container {\n        padding-left: 2rem;\n        height: 300px;\n    }\n\n    .appointment-view {\n        /* margin: 0rem 1rem 3.5rem; */\n        padding: 1rem 2rem;\n    }\n\n    .doc-nav-left {\n        width: 24px;\n        height: auto;\n        margin-left: -42px;\n    }\n\n    .doc-nav-right {\n        width: 24px;\n        height: auto;\n        margin-right: -41px;\n    }\n\n    .main-title {\n        font-size: 40px;\n        line-height: 40px;\n        padding-top: 10px;\n    }\n\n    .calendar-view {\n        padding-right: 0px\n    }\n\n    .react-calendar__month-view__weekdays {\n        font-size: 12px !important;\n    }\n\n    .react-calendar__tile {\n        font-size: 12px !important;\n        height: 25px;\n        padding: 0px !important;\n    }\n\n    .react-calendar__navigation button {\n        min-width: 22px !important;\n    }\n\n    .selected-date p {\n        font-size: 16px;\n    }\n\n    .react-calendar__tile--active::after {\n        width: 4px;\n        height: 4px;\n        bottom: 2px;\n        left: 11px;\n    }\n\n    .time-slot {\n        padding: 4px 10px;\n        font-size: 12px;\n        line-height: 20px;\n        margin-right: 5px;\n        margin-bottom: 10px;\n        width: 80px;\n    }\n\n    .note-style {\n        font-size: 16px;\n        line-height: 22px;\n    }\n\n    .appoiment-btn-container {\n        margin-top: 0px;\n    }\n\n    .appoiment-btn {\n        padding: 10px 20px;\n        font-size: 14px;\n    }\n\n    .doctor_right_view h3 {\n        font-size: 18px;\n        line-height: 22px;\n    }\n\n    .doctor_right_view {\n        font-size: 13px;\n        line-height: 18px;\n    }\n\n    .react-calendar__navigation button span {\n        font-size: 15px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
